
import NavBarV2 from "../../NavBarV2";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import "../../../WorkSpace/font.css";
import "../../Workspace2/sidebar.css";
import {
  cities,
  country,
  getTrialBalance,
  signupV2,
  state,
} from "../ApiServices/apiHandler";
import axios from "axios";
import swal from "sweetalert";
import GoogleLogin from "react-google-login";
import { useDispatch } from "react-redux";
import * as actionTypes from "../../../redux/actionTypes";
import { Link } from "react-router-dom";

import accountant from "../../../assets/signIn.svg";
import signInCss from "../../../myfin_v2/css/signIn.module.css"
import commoncss from "../../../myfin_v2/css/common.module.css"
import companycss from "../../../myfin_v2/css/company.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import { ReactComponent as MyFinLogo } from "../../../myfin_v2/assets/icons/myfinLogo.svg"
import { ReactComponent as HideIcon } from "../../../myfin_v2/assets/icons/hide.svg"
import { ReactComponent as ShowIcon } from "../../../myfin_v2/assets/icons/show.svg"
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import Dropdown from "../../../myfin_v2/elements/Dropdown";

const SignUp = (props) => {
  const [ShowPwd, setShowPwd] = useState(false);
  const [Cpassword, setCPwd] = useState(false);
  const [allstate, setStateData] = useState([]);
  const [allcountry, setCountryData] = useState([]);
  const [allcities, setCitiesData] = useState([]);
  const dispatch = useDispatch();

  const [error, seterror] = useState({
    org_name: true,
    email: true,
    password: true,
    confirmPwd: true,
  });
  const [Value, setValue] = useState({
    org_name: "",
    email: "",
    password: "",
    confirmPwd: "",
    city: "",
    state: "",
    isAdmin: "Yes",
    approved: "no"
  });
  useEffect(() => {
    validation();
  }, []);
  function validation() {
    let temp = { ...error };
    const pattern =
      /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,10}[\.][a-z]{2,5}/g;
    temp.org_name =
      Value.org_name | (Value.org_name.length === 0) ? true : false;
    temp.email =
      pattern.test(Value.email) | (Value.email.length === 0) ? true : false;
    temp.password =
      (Value.password.length > 6) | (Value.password.length === 0)
        ? true
        : false;
    temp.confirmPwd =
      (Value.password === Value.confirmPwd) | (Value.confirmPwd.length === 0)
        ? true
        : false;
    seterror(temp);
  }

  const stateData = async () => {
    const res = await state();
    const stateall = res.data.StateData.state.map((data) => data.name);
    setStateData(stateall);
  };
  const countryData = async () => {
    const rescountry = await country();
    const countryall = rescountry.data.CountryData.country.map(
      (data) => data.name
    );
    setCountryData(countryall);
  };
  const citiesData = async () => {
    const rescities = await cities();
    const citiesall = rescities.data.CitiesData.cities.map((data) => data.name);
    setCitiesData(citiesall);
  };

  function handleChange(field, value) {
    setValue({ ...Value, [field]: value });
  }

  const handleSignUp = async () => {
    try {
      if (
        (Value.email.length === 0) |
        (Value.password.length === 0) |
        (Value.confirmPwd.length === 0)
      ) {
        swal("", "fill all the required fields!", "warning");
      }
      if (Value.password.length < 8) {
        swal("", "Password must be at least 8 characters long!", "warning");
        return;
      }

      else {
        let data = {
          org_name: Value.org_name,
          email: Value.email,
          password: Value.password,
          confirmPwd: Value.confirmPwd,
          state: Value.state,
          country: Value.country,
          isAdmin: Value.isAdmin,
          approved: Value.approved
        };

        const result = await signupV2(data);
        if (result.status === 200) {
          props.history.push(`/validation/${result.data.user._id}`);
        } else {
          swal("", result.data.error, "danger");
          console.log("hello")

        }
      }
    } catch (error) {
      swal("Error", error.response.data.error, "error")
    }

  };

  const onInputChange = (event, value) => {
    if (value && value.length > 3) {
      stateData();
    } else {
      setStateData([]);
    }
  };

  const onInputChangecity = (event, value) => {
    if (value && value.length > 3) {
      citiesData();
    } else {
      setCitiesData([]);
    }
  };

  const responseGoogle = (res) => {

    dispatch({
      type: actionTypes.SET_PROFILE_IMAGE,
      payload: res.profileObj.imageUrl,
    });
    dispatch({
      type: actionTypes.SET_PROFILE_EMAIL,
      payload: res.profileObj.email,
    });
    dispatch({
      type: actionTypes.SET_PROFILE_NAME,
      payload: res.profileObj.name,
    });
    const fd = new FormData();
    fd.append("name", res.profileObj.name);
    fd.append("email", res.profileObj.email);
    fd.append("profile_image", res.profileObj.imageUrl);
    fd.append("google_auth_token", res.googleId);
    axios
      .post("/api/v1/auth/gauth-signup", fd)
      .then((res) => {
        localStorage.setItem("auth_token", res.data.token);
        props.history.push("/company");
      })
      .catch((err) => {
        // console.log(err.response)
        // swal(err.response.data.error)
        swal("", err.response.data.error, "error");
        // swal("", err.response.data.error , "error");
      });
  };

  const responseError = (res) => {
    swal("", "hii chinmay", "error");
    // console.log(res,'error response from google')
  };

  return (
    <>
      <div className="conatiner">
        <div className={signInCss.imgContainer}>
          <img src={accountant} alt="accountant working" style={{
            "height": "93.7vh", "place-self": "center"
          }}></img>
        </div>
        <div className={signInCss.formContainer}>
          <div
            className={commoncss.dFlexJustifysb}

          >
            <div className={commoncss.dFlex}>
              <div className={commoncss.dFlexClm}>
                <span className={signInCss.heading1}>
                  Hello there!
                </span>
                <span className={signInCss.label1}>
                  Sign in or create an account to proceed
                </span>
              </div>
            </div>
            <div>
              <MyFinLogo />
            </div>
          </div>
          <div className={signInCss.container2} style={{ "margin-top": "10px" }}>
            <div className="button-group">
              <Link to="">
                <button
                  className={`${buttoncss.secondary}`}
                  style={{ "border-radius": "8.18px 0px 0px 8.18px", "padding": "5px 15px", "width": "130px" }}
                  onClick={() => {
                    // setRequestType("PULL");
                  }}
                >
                  Sign in
                </button>
              </Link>
              <button
                className={`${buttoncss.primary
                  }`}
                style={{
                  "border-radius": "0 8.18px 8.18px 0", "padding": "5px 15px", "width": "130px"
                }}
                onClick={() => {

                }}
              >
                Sign up
              </button>
            </div>
            <div className={`${signInCss.container3} mt-2`}>
              <InputGroup
                label="Email"
                inputs={[
                  <>
                    <input
                      name="email"
                      placeholder="Enter email id"
                      type="text"
                      onChange={(e) => handleChange("email", e.target.value)}
                    />

                  </>,
                ]}
              />
              <InputGroup
                class_="mb-0"
                inputs={[
                  <>
                    <InputGroup
                      label="Organization Name"
                      inputs={[
                        <>
                          <input
                            name="org_name"
                            placeholder="Enter organization name"
                            type="text"
                            onChange={(e) => handleChange("org_name", e.target.value)}
                          />
                        </>,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Username"
                      inputs={[
                        <>
                          <input
                            name=""
                            placeholder="Enter username"
                            type="text"
                            onChange={(e) => { }}
                          />

                        </>,
                      ]}
                    />

                  </>,
                ]}
              />

              <InputGroup
                label="Password"
                inputs={[
                  <>
                    <input
                      id="fname"
                      name="password"
                      placeholder="Enter password"
                      type={!ShowPwd ? "password" : "text"}
                      onChange={(e) => handleChange("password", e.target.value)}
                    />
                    <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={() => setShowPwd(!ShowPwd)}>
                      {ShowPwd ? <ShowIcon height={18} /> : <HideIcon height={18} />}
                    </span>

                  </>,
                ]}
              />

              <InputGroup
                label="Confirm Password"
                inputs={[
                  <>
                    <input
                      id="fname"
                      name="confirmPwd"
                      placeholder="Confirm password"
                      type={!Cpassword ? "password" : "text"}
                      onChange={(e) => handleChange("confirmPwd", e.target.value)}
                    />

                  </>,
                ]}
              />
              {/* <InputGroup
                label="Select City"
                inputs={[
                  <>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      // options={allcities?allcities:[]}
                      options={!allcities ? [] : allcities}
                      onChange={(e, value) => handleChange("city", value, e)}
                      onInputChange={onInputChangecity}
                      sx={{ width: 350, backgroundColor: "white" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label=<LocationOnIcon />
                          inputProps={{
                            ...params.inputProps,
                            style: {
                              border: "none",
                            },
                          }}
                        />
                      )}
                    />

                  </>,
                ]}
              />

              <InputGroup
                label="Select State"
                inputs={[
                  <>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      // options={allstate?allstate:[]}
                      options={!allstate ? [] : allstate}
                      onChange={(e, value) => handleChange("state", value)}
                      onInputChange={onInputChange}
                      sx={{ width: 350, marginLeft: 5, backgroundColor: "white" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label=<LocationOnIcon />
                          inputProps={{
                            ...params.inputProps,
                            style: {
                              border: "none",
                            },
                          }}
                        />
                      )}
                    />

                  </>,
                ]}
              /> */}

              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Select City"
                      inputs={[
                        <>
                          <Dropdown
                            options={[].map((connectiontype) => ({
                              label: connectiontype.label,
                              value: connectiontype.value,
                            }))}
                            onSelect={(sel) => { }}
                            placeHolder={"Select City"}
                          />
                        </>,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Select State"
                      inputs={[
                        <>
                          <Dropdown
                            options={[].map((connectiontype) => ({
                              label: connectiontype.label,
                              value: connectiontype.value,
                            }))}
                            onSelect={(sel) => { }}
                            placeHolder={"Select State"}

                          // placeHolder={"Connection Type"}
                          // selected={{ label: "OAuth", value: "OAuth" }}
                          />
                        </>,
                      ]}
                    />
                  </>,
                ]}
              />
              <div className="w-100 mt-2" onClick={handleSignUp}>
                <button type="submit" className={buttoncss.primary} style={{ "padding": "7px", "width": "100%", "border-radius": "12px" }}>Create Account
                </button>
              </div>
              <div className={signInCss.label3}>
                <span>Have an account already?</span> <Link to="/" className={signInCss.label2}>Sign in</Link>
              </div>
            </div>
            <div
              className={`w-100 ${signInCss.tnc}`} style={{ "margin-top": "10px" }}
            >
              <span>
                <span className={signInCss.label1}>By joining, you agree to the</span><span className={signInCss.label2}>Terms and Privacy Policy</span>
              </span>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default SignUp;
